/* BONPLANCALENDRIER — theme.js */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CFG = window.bpc || {};

  /* ---------- Formattazione prezzi ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Tiroirs ---------- */
  var overlay = $('.overlay');
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    var f = el.querySelector('button,a,input');
    if (f) f.focus();
  }
  function closeDrawers() {
    $$('.drawer').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer($('#' + open.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('overlay')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Header + torna su ---------- */
  var header = $('.header'), top = $('.to-top'), tick = false;
  function onScroll() {
    if (tick) return;
    tick = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset;
      if (header) header.classList.toggle('is-stuck', y > 12);
      if (top) top.classList.toggle('is-on', y > 700);
      tick = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- Compte à rebours vers une date réelle ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function countdowns() {
    var hosts = $$('[data-countdown]');
    if (!hosts.length) return;

    hosts.forEach(function (host) {
      var target = new Date(host.getAttribute('data-countdown') + 'T00:00:00');
      var over = host.querySelector('[data-cd-over]');
      var grid = host.querySelector('[data-cd-grid]');

      function tickOne() {
        var left = Math.floor((target - new Date()) / 1000);
        if (isNaN(left) || left <= 0) {
          if (grid) grid.hidden = true;
          if (over) over.hidden = false;
          return;
        }
        var d = Math.floor(left / 86400);
        var h = Math.floor((left % 86400) / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        var set = function (k, v) {
          var el = host.querySelector('[data-' + k + ']');
          if (el && el.firstChild) el.firstChild.nodeValue = pad(v);
        };
        set('d', d); set('h', h); set('m', m); set('s', s);
      }
      tickOne();
      setInterval(tickOne, 1000);
    });
  }

  /* ---------- Date di consegna ---------- */
  var GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
  var MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
  function ouvres(d, n) {
    var x = new Date(d.getTime()), i = 0;
    while (i < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) i++; }
    return x;
  }
  function fmtDate(d) { return GIORNI[d.getDay()] + ' ' + d.getDate() + ' ' + MESI[d.getMonth()]; }

  function delivery() {
    var cfg = CFG.delivery || { min: 1, max: 2, cutoff: 14 };
    var base = new Date();
    if (base.getHours() >= cfg.cutoff) base = ouvres(base, 1);
    var d1 = ouvres(base, cfg.min), d2 = ouvres(base, cfg.max);

    $$('[data-delivery]').forEach(function (el) {
      var txt = cfg.min === cfg.max
        ? 'Consegna stimata <b>' + fmtDate(d1) + '</b>.'
        : 'Consegna stimata tra <b>' + fmtDate(d1) + '</b> e <b>' + fmtDate(d2) + '</b>.';
      el.innerHTML = txt;
    });

    /* Arriva prima della data indicata ? */
    $$('[data-before]').forEach(function (el) {
      var iso = el.getAttribute('data-before');
      var limit = new Date(iso + 'T23:59:59');
      if (isNaN(limit)) { el.hidden = true; return; }
      if (new Date() > limit) { el.hidden = true; return; }
      var ok = d2 <= limit;
      el.hidden = false;
      var label = el.getAttribute('data-before-label') || 'stasera';
      el.querySelector('[data-before-txt]').innerHTML = ok
        ? 'Ordinando adesso, il tuo pacco arriva <b>entro ' + label + '</b>.'
        : 'Ordinando adesso, la consegna potrebbe superare ' + label + '.';
    });
  }


  /* ---------- Pixel TikTok : événements dynamiques ---------- */
  function ttqTrack(event, payload) {
    var cfg = window.polTtq;
    if (!cfg || !cfg.on || typeof window.ttq === 'undefined') return;
    try {
      if (cfg.test) window.ttq.track(event, payload, { event_id: cfg.test });
      else window.ttq.track(event, payload);
    } catch (e) { /* il pixel non deve mai rompere il carrello */ }
  }

  function ttqCartPayload(cart) {
    return {
      contents: (cart.items || []).map(function (it) {
        return {
          content_id: String(it.variant_id),
          content_type: 'product',
          content_name: it.product_title,
          quantity: it.quantity,
          price: it.final_price / 100
        };
      }),
      value: (cart.total_price || 0) / 100,
      currency: (window.polTtq && window.polTtq.currency) || 'EUR'
    };
  }

  /* ---------- Carrello ---------- */
  function refreshCartCount() {
    fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        renderDrawer(cart);
      })
      .catch(function () { });
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    return fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!res.ok) { toast(res.data.description || 'Prodotto non disponibile'); return; }
        if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); }
        var added = (res.data.items && res.data.items[0]) || res.data;
        if (added && added.variant_id) {
          ttqTrack('AddToCart', {
            contents: [{
              content_id: String(added.variant_id),
              content_type: 'product',
              content_name: added.product_title || added.title || '',
              quantity: added.quantity || qty || 1,
              price: (added.final_price || added.price || 0) / 100
            }],
            value: ((added.final_price || added.price || 0) * (added.quantity || qty || 1)) / 100,
            currency: (window.polTtq && window.polTtq.currency) || 'EUR'
          });
        }
        refreshCartCount();
        openDrawer($('#cart-drawer'));
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        toast('Errore di rete, riprova.');
      });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart(quick.getAttribute('data-quick-add'), 1, quick);
    }
  });


  /* ---------- Barra spedizione gratuita ---------- */
  function renderShip(cart) {
    var el = $('[data-ship]');
    if (!el) return;
    var cfg = CFG.freeShip || { on: false, threshold: 0 };
    if (!cfg.on || !cfg.threshold || !cart.item_count) { el.hidden = true; return; }
    var left = cfg.threshold - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / cfg.threshold) * 100));
    el.hidden = false;
    if (left <= 0) {
      el.className = 'ship ship--ok';
      el.innerHTML = '<p class="ship__t ship__t--ok">Spedizione gratuita sbloccata.</p>' +
        '<div class="ship__bar"><div class="ship__fill" style="width:100%"></div></div>';
    } else {
      el.className = 'ship';
      el.innerHTML = '<p class="ship__t">Restano <b>' + money(left) + '</b> per la spedizione gratuita</p>' +
        '<div class="ship__bar"><div class="ship__fill" style="width:' + pct + '%"></div></div>';
    }
  }

  function renderDrawer(cart) {
    renderShip(cart);
    var body = $('[data-cart-items]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty" style="padding:48px 0"><p>Il tuo carrello è vuoto.</p><a class="btn btn--primary" href="/collections/all">Vedi la collezione</a></div>';
      var f = $('[data-cart-foot]'); if (f) f.hidden = true;
      return;
    }
    var html = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<div class="line">' +
        '<div class="line__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="96" height="96">' : '') + '</div>' +
        '<div><p class="line__t">' + it.product_title + '</p>' +
        (it.variant_title ? '<p class="line__v">' + it.variant_title + '</p>' : '') +
        '<div class="qty"><button type="button" data-line-qty="' + it.key + '" data-dir="-1" aria-label="Réduire">−</button>' +
        '<input type="number" value="' + it.quantity + '" min="0" data-line-input="' + it.key + '" aria-label="Quantité">' +
        '<button type="button" data-line-qty="' + it.key + '" data-dir="1" aria-label="Augmenter">+</button></div>' +
        '<button class="line__rm" type="button" data-line-remove="' + it.key + '">Retirer</button></div>' +
        '<div class="line__p">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    body.innerHTML = html;
    var foot = $('[data-cart-foot]');
    if (foot) { foot.hidden = false; var t = $('[data-cart-total]'); if (t) t.textContent = money(cart.total_price); }
  }

  function changeLine(key, qty) {
    fetch(CFG.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      var key = q.getAttribute('data-line-qty');
      var input = $('[data-line-input="' + key + '"]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-dir'), 10));
      changeLine(key, next);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) changeLine(rm.getAttribute('data-line-remove'), 0);
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.getAttribute('data-line-input'), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Quantité (PDP) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
  });

  /* ---------- Galerie ---------- */
  function gallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full');
        var im = t.querySelector('img');
        main.alt = im ? im.alt : '';
        $$('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Variantes ---------- */
  function variants() {
    var root = $('[data-product-root]');
    if (!root) return;
    var dataEl = $('[data-variants-json]');
    if (!dataEl) return;
    var list = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]');
    var btn = $('[data-add-btn]');
    var priceNow = $('[data-price-now]');
    var priceWas = $('[data-price-was]');
    var priceSave = $('[data-price-save]');
    var main = $('[data-gallery-main]');

    function selected() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (i) { return i.value; });
    }

    function update() {
      var opts = selected();
      var v = list.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      var has = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) {
        priceWas.textContent = has ? money(v.compare_at_price) : '';
        priceWas.hidden = !has;
      }
      if (priceSave) {
        var pct = has ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        priceSave.textContent = has ? '−' + pct + ' %' : '';
        priceSave.hidden = !has;
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? CFG.strings.addToCart : CFG.strings.soldOut;
      }
      if (v.featured_image && main) main.src = v.featured_image.src;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      var bb = $('[data-buybar-price]');
      if (bb) bb.textContent = money(v.price);
      updateStock(v);
    }
    $$('[data-option-index]', root).forEach(function (i) { i.addEventListener('change', update); });
    update();
  }

  function updateStock(v) {
    var host = $('[data-stock-host]');
    if (!host) return;
    var threshold = CFG.lowStock || 8;
    var tracked = v.inventory_management && v.inventory_policy === 'deny';
    var qty = v.inventory_quantity || 0;
    if (!v.available) { host.innerHTML = ''; return; }
    if (tracked && qty > 0 && qty <= threshold) {
      var pct = Math.max(6, Math.round((qty / threshold) * 100));
      host.innerHTML =
        '<div class="stock"><div class="stock__bar"><div class="stock__fill" style="width:' + pct + '%"></div></div>' +
        '<p class="stock__txt"><span class="stock__dot"></span>Restano solo ' + qty + ' pezzi — nessun riassortimento</p></div>';
    } else {
      host.innerHTML =
        '<div class="stock"><p class="stock__txt stock__txt--ok"><span class="stock__dot"></span>Disponibile, spedizione entro 24 h</p></div>';
    }
  }

  /* ---------- Raccomandazioni ---------- */
  function recommendations() {
    $$('[data-recommendations]').forEach(function (host) {
      var url = host.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.querySelector('.pcard')) host.innerHTML = fresh.innerHTML;
          else host.remove();
        })
        .catch(function () { host.remove(); });
    });
  }

  /* ---------- Récemment consultés ---------- */
  var RV_KEY = 'bpc:viewed';

  function rememberProduct() {
    var el = $('[data-product-handle]');
    if (!el) return;
    var handle = el.getAttribute('data-product-handle');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }

  function recentlyViewed() {
    var host = $('[data-recently-viewed]');
    if (!host) return;
    var grid = $('[data-recently-grid]', host);
    var current = $('[data-product-handle]');
    var currentHandle = current ? current.getAttribute('data-product-handle') : null;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return; }
    list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 5);
    if (!list.length) return;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '?section_id=card-ajax')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      if (!html.trim()) return;
      grid.innerHTML = html;
      host.hidden = false;
    });
  }

  /* ---------- Barra d'acquisto ---------- */
  function buybar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-add-btn]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '-70px 0px 0px 0px' }).observe(anchor);
    bar.querySelector('button').addEventListener('click', function () { anchor.click(); });
  }

  /* ---------- Filtres de collection ---------- */
  function facets() {
    var form = $('[data-facet-form]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') form.submit();
    });
  }

  /* ---------- Accordéons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.acc__b');
    if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    if (panel) panel.classList.toggle('is-open', !open);
  });

  /* ---------- Avis : afficher plus ---------- */
  function reviewsMore() {
    var btn = $('[data-reviews-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var list = btn.closest('[data-reviews-list]');
      var hidden = $$('.rv__item.is-hidden', list);
      if (hidden.length) {
        hidden.forEach(function (el) { el.classList.remove('is-hidden'); });
        btn.textContent = btn.getAttribute('data-label-less');
        btn.setAttribute('data-open', 'true');
      } else if (btn.getAttribute('data-open') === 'true') {
        var visible = parseInt(btn.getAttribute('data-visible'), 10);
        $$('.rv__item', list).forEach(function (el, i) {
          if (i + 1 > visible) el.classList.add('is-hidden');
        });
        btn.textContent = btn.getAttribute('data-label-more');
        btn.setAttribute('data-open', 'false');
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    var list = btn.closest('[data-reviews-list]');
    var shown = $$('.rv__item', list).length - $$('.rv__item.is-hidden', list).length;
    btn.setAttribute('data-visible', shown);
  }

  /* ---------- Tracciamento ordine ---------- */
  function tracking() {
    var form = $('[data-track-form]');
    if (!form) return;

    var carriers = [];
    var data = $('[data-carriers]');
    if (data) { try { carriers = JSON.parse(data.textContent) || []; } catch (e) { carriers = []; } }

    var input = form.querySelector('[data-track-input]');
    var found = form.querySelector('[data-track-found]');

    function detect(num) {
      var clean = num.replace(/\s+/g, '').toUpperCase();
      for (var i = 0; i < carriers.length; i++) {
        var c = carriers[i];
        if (!c.pattern || !c.url) continue;
        try {
          if (new RegExp(c.pattern, 'i').test(clean)) return c;
        } catch (e) { /* motif invalide : on ignore ce transporteur */ }
      }
      return null;
    }

    if (input && found) {
      input.addEventListener('input', function () {
        var num = (input.value || '').trim();
        if (num.length < 6) { found.hidden = true; return; }
        var c = detect(num);
        found.hidden = false;
        found.style.fontSize = '12.5px';
        found.style.margin = '-6px 0 14px';
        found.style.color = c ? 'var(--trust)' : 'var(--ink-3)';
        found.textContent = c
          ? 'Transporteur détecté : ' + c.name
          : 'Corriere non riconosciuto — apriremo il tracciamento predefinito.';
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = (input.value || '').trim().replace(/\s+/g, '');
      if (!num) { toast('Inserisci il tuo numero di tracciamento.'); return; }
      var c = detect(num);
      var base = c ? c.url : (form.getAttribute('data-carrier-url') || '');
      if (!base) { toast('Nessun corriere configurato.'); return; }
      window.open(base + encodeURIComponent(num), '_blank', 'noopener');
    });
  }


  /* ---------- InitiateCheckout ---------- */
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[name="checkout"], [href$="/checkout"], [data-checkout]');
    if (!go) return;
    fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { ttqTrack('InitiateCheckout', ttqCartPayload(cart)); })
      .catch(function () {});
  }, true);


  /* ---------- Recherche prédictive ---------- */
  function predictive() {
    var inputs = $$('[data-psearch-input]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var box = input.parentNode.querySelector('[data-psearch]');
      if (!box) return;
      var timer, controller, idx = -1;

      function hide() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); idx = -1; }

      function render(data, q) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          box.innerHTML = '<p class="psearch__empty">Nessun risultato per « ' + q.replace(/[<>&]/g, '') + ' »</p>';
          box.hidden = false; input.setAttribute('aria-expanded', 'true');
          return;
        }
        var html = '<p class="psearch__k">Prodotti</p>';
        items.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          var was = (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price))
            ? '<s>' + p.compare_at_price_max + '</s>' : '';
          html += '<a class="psearch__i" href="' + p.url + '" role="option">' +
            '<span class="psearch__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span><span class="psearch__t">' + p.title + '</span>' +
            '<span class="psearch__p">' + p.price + was + '</span></span></a>';
        });
        html += '<a class="psearch__all" href="' + CFG.routes.search + '?q=' + encodeURIComponent(q) + '">Vedi tutti i risultati</a>';
        box.innerHTML = html;
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { hide(); return; }
        timer = setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          var url = (CFG.routes.predictive || '/search/suggest') +
            '?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url + '&section_id=', { signal: controller.signal })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
            .then(function (data) { render(data, q); })
            .catch(function () {});
        }, 220);
      });

      input.addEventListener('keydown', function (e) {
        var opts = $$('.psearch__i', box);
        if (e.key === 'Escape') { hide(); input.blur(); return; }
        if (!opts.length || box.hidden) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          idx = e.key === 'ArrowDown' ? Math.min(idx + 1, opts.length - 1) : Math.max(idx - 1, 0);
          opts.forEach(function (o, i) { o.classList.toggle('is-on', i === idx); });
          opts[idx].scrollIntoView({ block: 'nearest' });
        }
        if (e.key === 'Enter' && idx > -1) { e.preventDefault(); window.location.href = opts[idx].href; }
      });

      document.addEventListener('click', function (e) {
        if (!input.parentNode.contains(e.target)) hide();
      });
    });
  }


  /* ---------- Vérificateur d'encombrement ---------- */
  function fitChecker() {
    var form = $('[data-fit]');
    if (!form) return;
    var w = parseFloat(form.getAttribute('data-w')) || 0;
    var d = parseFloat(form.getAttribute('data-d')) || 0;
    var out = $('[data-fit-out]', form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var uw = parseFloat(form.querySelector('[data-fit-w]').value.replace(',', '.'));
      var ud = parseFloat(form.querySelector('[data-fit-d]').value.replace(',', '.'));
      if (!uw && !ud) { return; }

      var okW = !uw || !w || uw >= w;
      var okD = !ud || !d || ud >= d;
      var margeW = uw && w ? (uw - w).toFixed(0) : null;

      out.hidden = false;
      if (okW && okD) {
        out.className = 'fit__out is-ok';
        out.innerHTML = '<b>Ça passe.</b> ' +
          (margeW !== null ? 'Ti resteranno circa ' + margeW + ' cm di margine in larghezza. ' : '') +
          'Considera anche il passaggio della porta e le scale: i pacchi vengono consegnati piatti.';
      } else {
        out.className = 'fit__out is-no';
        var manque = [];
        if (!okW) manque.push('largeur (' + w + ' cm nécessaires)');
        if (!okD) manque.push('profondeur (' + d + ' cm nécessaires)');
        out.innerHTML = '<b>C\'est trop juste en ' + manque.join(' et en ') + '.</b> ' +
          'Guarda i modelli più compatti della stessa gamma, oppure scrivici: ti orientiamo noi.';
      }
    });
  }

  /* ---------- Init ---------- */
  function init() {
    countdowns(); delivery(); predictive(); fitChecker(); gallery(); variants(); buybar(); facets(); tracking(); reviewsMore();
    rememberProduct(); recommendations(); recentlyViewed();
    if ($('#cart-drawer')) refreshCartCount();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
